export default __webpack_public_path__ + "static/media/icon-facebook.6e19b500.svg";